var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"domain-detail-whois"},[_c('page-block',{attrs:{"title":`${_vm.$t('title')} ${_vm.tariff.pricelist} #${_vm.tariff.id} ${_vm.tariff.period}`}},[_c('main-card',[_c('div',{ref:"whois",staticClass:"domain-detail-whois__content standart-text"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }